/* ==========================================================================
 *  Function: Pulling object
 * ======================================================================= */
function componentPulling() {
  if ($('.js-pulling').length && $window.width() > bpSmall) {
    $('.js-pulling').mouseleave(function (e) {
      TweenMax.to('.js-pulling', 0.3, { scale: 1, x: 0, y: 0 })
    })

    $('.js-pulling').mousemove(function (e) {
      callParallax(e)
    })

    function callParallax(e) {
      parallaxIt(e, '.js-pulling', 60)
    }

    function parallaxIt(e, target, movement) {
      var $this = $(e.currentTarget)
      var relX = e.pageX - $this.offset().left
      var relY = e.pageY - $this.offset().top

      TweenMax.to($(e.currentTarget), 0.3, {
        x: ((relX - $this.width() / 2) / $this.width()) * movement,
        y: ((relY - $this.height() / 2) / $this.height()) * movement,
        ease: Power2.easeOut,
      })
    }
  }
}
